import React, { useEffect, useState } from "react";
import Apiurl from "../../Helpers/apiUrl";
import axios from "axios";
import {
  CircularProgress,
  Box,
  Typography,
  Dialog,
  Fade,
  Skeleton,
  Tooltip,
} from "@mui/material";

const InventoryPopUp = ({ sku, onMouseEnter, onMouseLeave }) => {
  const [data, setData] = useState(null);
  
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchStock = async () => {
      if (!sku) {
        setData(null);
        return;
      }
      // if (!sku || localStorage.getItem('inventory_visible') !== 'true') {
      //   setData(null);
      //   return;
      // }
      setLoading(true);
      try {
        const token = localStorage.getItem("u_token");
        const response = await axios.get(
          `${Apiurl}user/inventory?search=${sku}&exact=true`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        if (response.data && response.data.data) {
          setData(response.data.data);
        } else {
          setData(null);
        }
      } catch (error) {
        setData(null);
      } finally {
        setLoading(false);
      }
    };
    fetchStock();
  }, [sku]);

  const formatStockValue = (num) => {
    if (!num || isNaN(num) || num === 0) return "0";
    const val = Math.abs(num);
    if (val >= 10000000) return (num / 10000000).toFixed(1) + " Cr";
    if (val >= 100000) return (num / 100000).toFixed(1) + " L";
    if (val >= 1000) return (num / 1000).toFixed(1) + " K";
    return num.toString();
  };

  const getMonthInfo = () => {
    const now = new Date();
    const formatter = new Intl.DateTimeFormat("en-US", {
      month: "short",
      year: "numeric",
    });
    return {
      currentMonth: formatter
        .format(new Date(now.getFullYear(), now.getMonth(), 1))
        .toUpperCase(),
      nextMonth: formatter
        .format(new Date(now.getFullYear(), now.getMonth() + 1, 1))
        .toUpperCase(),
    };
  };

  const { currentMonth, nextMonth } = getMonthInfo();

  const fullForms = [
    { code: "F", description: "Fast moving skus", type: "FMR" },
    { code: "M", description: "Medium Moving skus", type: "FMR" },
    { code: "R", description: "Rare Moving skus", type: "FMR" },
    { code: "Pruned", description: "Pruned", type: "FMR/Stock Indicator" },
    {
      code: "MTS",
      description: "Make to stock - Salable skus or fast moving",
      type: "Stock Indicator",
    },
    {
      code: "MTO",
      description: "Make to Order - Order to be placed once order received",
      type: "Stock Indicator",
    },
    {
      code: "NPD",
      description: "New product development",
      type: "Stock Indicator",
    },
    { code: "Exposed", description: "Exposed", type: "Functionality" },
    { code: "concealed", description: "concealed", type: "Functionality" },
    { code: "Spare", description: "Spare", type: "Functionality" },
    { code: "Others", description: "Spare", type: "Functionality" },
  ];

  const indicatorInfo = data
    ? fullForms.find((item) => item.code === data.stockIndicator)
    : null;

  return (
    <Dialog
      open={Boolean(sku)}
      TransitionComponent={Fade}
      hideBackdrop={true}
      disableEnforceFocus
      disableRestoreFocus
      sx={{
        pointerEvents: "none",
        zIndex: 1300
      }}
      PaperProps={{
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        sx: {
          borderRadius: "10px",
          pointerEvents: "auto",
          width: "320px",
          overflow: "hidden",
          bgcolor: "#FFFFFF",
          boxShadow:
            "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
          border: "1px solid #E2E8F0",
        },
      }}
    >
      <Box
        sx={{
          bgcolor: "#1E293B",
          px: 2,
          py: 1.5,
          display: "flex",
          flexDirection: "column",
          gap: 0.5,
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              color: "#F8FAFC",
              fontSize: "13px",
              fontWeight: 800,
              letterSpacing: "0.5px",
            }}
          >
            {sku}
          </Typography>

          {!loading && data && (
            <Typography
              sx={{
                bgcolor: "#FCD34D",
                color: "#78350F",
                px: 0.8,
                py: 0.2,
                borderRadius: "4px",
                fontSize: "10px",
                fontWeight: 900,
              }}
            >
              {data.stockIndicator}
            </Typography>
          )}
        </Box>

        {!loading && data && (
          <Typography
            sx={{
              fontSize: "10px",
              color: "#94A3B8",
              fontWeight: 700,
              textTransform: "uppercase",
            }}
          >
            {fullForms.find((item) => item.code === data.stockIndicator)
              ?.description || ""}
          </Typography>
        )}
      </Box>

      <Box sx={{ p: 2.5 }}>
        {loading ? (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              py: 3,
            }}
          >
            <CircularProgress size={28} sx={{ color: "#1E293B", mb: 2 }} />
            <Typography
              sx={{ fontSize: "11px", color: "#64748B", fontWeight: 700 }}
            >
              SYNCING INVENTORY...
            </Typography>
          </Box>
        ) : data ? (
          <>
            <Box
              sx={{
                textAlign: "center",
                mb: 3,
                py: 1.5,
                borderRadius: "8px",
                bgcolor: data.stockAvailable > 0 ? "#F0FDF4" : "#FEF2F2",
                border:
                  data.stockAvailable > 0
                    ? "1px solid #BBF7D0"
                    : "1px solid #FECACA",
              }}
            >
              <Typography
                sx={{
                  fontSize: "10px",
                  color: data.stockAvailable > 0 ? "#166534" : "#991B1B",
                  fontWeight: 800,
                  letterSpacing: "1px",
                  mb: 0.5,
                }}
              >
                AVAILABLE STOCK
              </Typography>
              <Typography
                sx={{
                  fontSize: "36px",
                  fontWeight: 900,
                  color: data.stockAvailable > 0 ? "#15803D" : "#DC2626",
                  lineHeight: 1,
                }}
              >
                {formatStockValue(data.stockAvailable)}
              </Typography>
            </Box>

            {[
              { month: currentMonth, prefix: "cwk", color: "#2563EB" },
              { month: nextMonth, prefix: "nwk", color: "#475569" },
            ].map((m) => (
              <Box key={m.prefix} sx={{ mb: 2.5 }}>
                <Typography
                  sx={{
                    fontSize: "11px",
                    fontWeight: 800,
                    color: m.color,
                    mb: 1,
                    borderLeft: `3px solid ${m.color}`,
                    pl: 1,
                  }}
                >
                  {m.month}
                </Typography>
                <Box sx={{ display: "flex", gap: 0.75 }}>
                  {[1, 2, 3, 4].map((wk) => {
                    const val = data[`${m.prefix}_${wk}`] || 0;
                    const hasStock = val > 0;
                    return (
                      <Box
                        key={wk}
                        sx={{
                          flex: 1,
                          py: 1,
                          textAlign: "center",
                          bgcolor: hasStock ? "#F0FDF4" : "#FFFFFF",
                          border: hasStock
                            ? "1.5px solid #16A34A"
                            : "1px solid #E2E8F0",
                          borderRadius: "6px",
                          boxShadow: hasStock
                            ? "0 1px 2px rgba(0, 0, 0, 0.05)"
                            : "none",
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: "9px",
                            color: hasStock ? "#16A34A" : "#64748B",
                            fontWeight: 800,
                          }}
                        >
                          W{wk}
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "12px",
                            fontWeight: 800,
                            color: hasStock ? "#166534" : "#CBD5E1",
                          }}
                        >
                          {formatStockValue(val)}
                        </Typography>
                      </Box>
                    );
                  })}
                </Box>
              </Box>
            ))}
          </>
        ) : (
          <Box sx={{ py: 3, textAlign: "center" }}>
            <Typography
              sx={{ fontSize: "12px", fontWeight: 800, color: "#475569" }}
            >
              STOCK INFORMATION UNAVAILABLE
            </Typography>
          </Box>
        )}

        {!loading && data && data.updated_at && (
          <Box
            sx={{
              mt: 1,
              pt: 1.5,
              borderTop: "1px dashed #E2E8F0",
              display: "flex",
              justifyContent: "center"
            }}
          >
            <Typography
              sx={{
                fontSize: "10px",
                color: "#94A3B8",
                fontWeight: 600,
                fontStyle: "italic"
              }}
            >
              Last Updated: {new Date(data.updated_at).toLocaleString('en-IN', {
                day: '2-digit',
                month: 'short',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                hour12: true
              })}
            </Typography>
          </Box>
        )}
      </Box>
    </Dialog>
  );
};

export default InventoryPopUp;